import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  clickNode, closingNode, createNode, likeNode, editNode
} from '../../actions';
import NodeForm from './NodeForm'
import NodeEditForm from './NodeEditForm'
import SignupLink from '../SignupLogin/SignupLink'
import Rodal from 'rodal';
import locale from '../../common/locale'
import { Link } from "react-router-dom";
import 'rodal/lib/rodal.css';
import DeleteButton from './DeleteButton'
import StampButtons from './StampButtons'
import { parentNumber, idx } from '../../common/node'
import Cookies from 'universal-cookie';
import { escapeJS } from '../../common/node'

const cookies = new Cookies();

export class BaseNode extends Component {

  constructor(props) {
    super(props);
    this.state = { addModal: false, likeModal: false, editModal: false,
      liked: false };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { server, id } = this.props;
    if (id in server.liked) {
      this.setState({ liked: true })
    }
  }

  handleSubmit(data) {
    const { createNode, editNode, id, number } = this.props;
    if('text' in data) {
      createNode(data, id, number)
    } else if('editText' in data){
      editNode(data, id, number)
    }
    this.setState({ addModal: false, likeModal: false, editModal: false });
  }

  show() {
    this.setState({ addModal: true });
  }

  clickLike() {
    this.setState({ likeModal: true });
  }

  clickLikeSend() {
    this.setState({ liked: true });
    this.props.likeNode(this.props.id);
  }

  clickEdit() {
    this.setState({ editModal: true });
  }

  hide() {
    this.setState({ addModal: false, likeModal: false, editModal: false });
  }

  render() {
    const { id, number, client, server, x, y, clickNode, closingNode, page} = this.props
    if(typeof id === 'undefined'){
      return ( null )
    }

    const loc = cookies.get('locale')
    return(
      <div>
        <div className='node'
          style={{
            transform: `translate3d(
            ${x || client.x[number]}px,
            ${y || client.y[number]}px,
            0px)`,
            zIndex:`${zIndex(number)}`,
            color: `${color(client.activeNode, number)}`}}>

            { server.contents[id]['html']
                ? (
                  <div className='url'
                    onMouseDown={e => clickNode(e, id, number, x || client.x[number], y || client.y[number], page) }
                    onTouchStart={e => clickNode(e, id, number, x || client.x[number], y || client.y[number], page) }
                    style={{cursor: 'pointer'}} >
                    { (client.status[number] === 'opened')
                        ? (
                          <div dangerouslySetInnerHTML={{__html: server.contents[id]['html']}} />
                        )
                        : (
                          <div className='non-link' dangerouslySetInnerHTML={{__html: server.contents[id]['html']}} />
                        )
                    }
                    { (page !== 0 && Number(number.slice(-2)) >= 10)
                        ?(
                          <div className='next-label'>{locale.next_nodes(loc)}</div>
                        )
                        :(null)
                    }
                  </div>
                )
                : (
                  <div className='scroll'>
                    <div className='content'>
                      <div onMouseDown={e => clickNode(e, id, number, x || client.x[number], y || client.y[number]) }
                        onTouchStart={e => clickNode(e, id, number, x || client.x[number], y || client.y[number]) }
                        style={{cursor: 'pointer'}} >
                        { (client.status[number] === 'opened')
                            ? (
                              <p dangerouslySetInnerHTML={{__html: server.contents[id]['text']}} />
                            )
                            : (
                              <p className='non-link' dangerouslySetInnerHTML={{__html: server.contents[id]['text']}} />
                            )
                        }
                        { (page !== 0 && Number(number.slice(-2)) >= 10)
                            ?(
                              <div className='next-label'>{locale.next_nodes(loc)}</div>
                            )
                            :(null)
                        }
                      </div>
                    </div>
                  </div>
                )
            }

            { (client.status[number] === 'opened' && client.activeNode === number
              && number !== 'l')
                ? ( <div>
                  { (number !== 'm')
                      ? (
                        <div>
                          {
                            (number === client.fetchNodeNumber)
                              ? ( null )
                              : (
                                <div className='button close'
                                  onClick={e => { closingNode(number) } }
                                  style={{cursor: 'pointer'}}
                                > -
                                </div>
                              )

                          }
                          <div className='button add'
                            onClick={this.show.bind(this)}
                            style={{cursor: 'pointer'}} >
                            <i className="far fa-comment fa-lg" />
                            <span class="add-balloon">{locale.add_node(loc)}</span>
                          </div>
                          { ('owner_name' in server.contents[id] && server.contents[id]['owner_name'] !== 'admin')
                              ? (
                                <div className='owner'>
                                  <Link to={`/noders/${server.contents[id]['owner_name']}`} >
                                    @{server.contents[id]['owner_name']}
                                  </Link>
                                </div>
                              )
                              :( null )
                          }
                          { (cookies.get('api_access_token') === 'undefined'
                              || cookies.get('api_access_token') == null)
                              ? (
                                <div className='button like'
                                  onClick={this.clickLike.bind(this)}
                                  style={{cursor: 'pointer'}}>
                                  <i className="far fa-thumbs-up fa-lg" />
                                  <span class="stamp-balloon">{locale.like(loc)}</span>
                                </div>
                              )
                              : (
                                <div>
                                {
                                  (this.state.liked)
                                ? (
                                  <div className='button like active-stamp'
                                    style={{cursor: 'pointer'}}>
                                    <i className="far fa-thumbs-up fa-lg" />
                                    <span class="stamp-balloon">{locale.like(loc)}</span>
                                  </div>
                                )
                                : (
                                  <div className='button like'
                                    onClick={this.clickLikeSend.bind(this)}
                                    style={{cursor: 'pointer'}}>
                                    <i className="far fa-thumbs-up fa-lg" />
                                    <span class="stamp-balloon">{locale.like(loc)}</span>
                                  </div>
                                )
                                }
                                {
                                  (id in server.mine)
                                    ? (
                                      <div>
                                        <div className='button edit'
                                          onClick={this.clickEdit.bind(this)}
                                          style={{cursor: 'pointer'}}>
                                          <i class="fas fa-pencil-alt fa-lg" />
                                        </div>
                                        <DeleteButton id={id} number={number} />
                                      </div>
                                    )
                                    : ( null )
                                }
                              </div>
                              )
                          }
                          <StampButtons id={id} number={number} />
                        </div>
                      )
                      : ( null )
                  }

                </div> )
                : ( null )
            }
          </div>

          <Rodal visible={this.state.addModal} animation={'door'} onClose={this.hide.bind(this)}
            customStyles={customStyles} customMaskStyles={customMaskStyles} >
            { (cookies.get('api_access_token') === 'undefined'
              || cookies.get('api_access_token') == null)
              ? ( <SignupLink loc={loc} message='add' /> )
              : ( <NodeForm number={number} loc={loc}
                onSubmit={this.handleSubmit} /> )
            }
          </Rodal>

          <Rodal visible={this.state.likeModal} animation={'door'} onClose={this.hide.bind(this)}
            customStyles={customStyles} customMaskStyles={customMaskStyles} >
            { (cookies.get('api_access_token') === 'undefined'
              || cookies.get('api_access_token') == null)
              ? ( <SignupLink loc={loc} message='like' /> )
              : ( null )
            }
          </Rodal>

          <Rodal visible={this.state.editModal} animation={'door'} onClose={this.hide.bind(this)}
            customStyles={customStyles} customMaskStyles={customMaskStyles} >
            { (this.state.editModal)
                ? (
                  <NodeEditForm number={number} loc={loc}
                    id={id} initialValues={{editText: link_to_markdown(server.contents[id]['text'])}}
                    onSubmit={this.handleSubmit} />
                )
                : ( null )
            }
          </Rodal>
        </div>
    )
  }
}

const customStyles ={
  background: 'rgba(245,245,245,1)',
}

const customMaskStyles={
  position: 'absolute',
  background: 'rgba(100,100,100,.7)',
}

const color = (active, number) => {
  if(active === number || active === parentNumber(number)) {
    return ('#5D5D5D');
  }
  return ('#D6D6D6')
}

export const zIndex = number => {
  return(
    (number.split('.').length-1) *12 + 1 + (12 -idx(number))
  )
}

const reg = new RegExp("<a href=\'\(.*?\)\' target=\'_blank\'>\(.*?\)</a>", 'g');

const link_to_markdown = text => {
  return( escapeJS(text.replace(reg, "[" + "$2" + "]\(" + "$1" + "\)")))
}

const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

const mapDispatchToProps = {
  clickNode,
  closingNode,
  createNode,
  likeNode,
  editNode
}

export default connect(mapStateToProps, mapDispatchToProps)(BaseNode)



// WEBPACK FOOTER //
// ./src/components/nodes/BaseNode.js